<template>
  <div>
    <v-tabs flat color="white">
      <v-tab
        v-for="item in items"
        :key="item"
      >
        {{item}}
      </v-tab>
      <v-tab-item
        v-for="item in items"
        :key="item"
      >
        <v-card flat>
          <img v-if="item === 'Aktiva'" src="static/mockups/md01.png" >
          <img v-if="item === 'Passiva'" src="static/mockups/md02.png" >
          <img v-if="item === 'GuV'" src="static/mockups/md03.png" >
          <img v-if="item === 'Sonstige'" src="static/mockups/nmd01.png" >
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'MockupSB01',
  data: () => ({
    currentItem: 'tab-Web',
    items: [
      'Aktiva', 'Passiva', 'GuV','Sonstige'
    ],
    more: [],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }),

  methods: {
    addItem (item) {
      const removed = this.items.splice(0, 1)
      this.items.push(
        ...this.more.splice(this.more.indexOf(item), 1)
      )
      this.more.push(...removed)
      this.$nextTick(() => { this.currentItem = 'tab-' + item })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/module/mockups/MockupRB01.vue